import React, { Component } from 'react';
import { getMessages, waiveConversation, takeConversation, closeConversation, sendMessage, saveConversation } from '../../../../utility/conversation';
import { addMessage } from '../../../../actions/messages';
import { setOutboundMessage } from '../../../../actions/outboundMessages';
import { withUser } from '../../../../utility/withUser';
import { getStandardTexts } from '../../../../utility/standardText';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import WaitForState from '../../../WaitForState';
import moment from 'moment';
import 'moment/locale/da';
import './index.css';
import {emojify} from 'react-emojione';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import { getTags, tagConversation, untagConversation } from '../../../../utility/tag';

/**
 * Component for showing conversation.
 *
 * @extends React.Component
 */
class Conversation extends Component {
  /** @inheritdoc */
  constructor(props) {
    super(props);
    this.state = {
      messages: null,
      outboundMessage: null,
      doneWorking: true,
      allTags: null,
      standardTexts: null,
      tags: [],
      notes: props.conversation.notes || "",
      age: props.conversation.age || "",
      gender: props.conversation.gender || "_none",
      scrolledToBottom: true,
    }
  }

  /**
   * Handle when a user wishes to take the conversation.
   */
  handleTake = (e) => {
    e.preventDefault();
    if (window.confirm("Er du sikker på at du vil overtage samtalen?")) {
      this.setState({doneWorking: false});
      takeConversation(this.props.conversation.id, this.props.token, this.props.history, (response) => {
        this.setState({doneWorking: true});
        if (response.status !== 200) {
          this.props.dispatch(addMessage('Fejl under ændring af samtale. Prøv venligst igen senere.', 'danger'));
          return;
        }
        this.props.onConversationUpdate();
      });
    }
  }

  /**
   * Handle when a user wishes to waive a conversation.
   */
  handleWaive = (e) => {
    e.preventDefault();
    if (window.confirm("Er du sikker på at du vil lægge samtalen tilbage i kø?")) {
      this.setState({doneWorking: false});
      waiveConversation(this.props.conversation.id, this.props.token, this.props.history, (response) => {
        this.setState({doneWorking: true});
        if (response.status !== 200) {
          this.props.dispatch(addMessage('Fejl under ændring af samtale. Prøv venligst igen senere.', 'danger'));
          return;
        }
        this.props.onConversationUpdate();
      });
    }
  }

  /**
   * Handle when a user wishes to close a conversation.
   */
  handleClose = (e) => {
    e.preventDefault();
    if (window.confirm("Er du sikker på at du vil lukke samtalen?")) {
      var sendClose = false;
      if (window.confirm("Vil du sende en afsluttende SMS?")) {
        sendClose = true;
      }
      this.setState({doneWorking: false});
      closeConversation(this.props.conversation.id, sendClose, this.props.token, this.props.history, (response) => {
        this.setState({doneWorking: true});
        if (response.status !== 200) {
          this.props.dispatch(addMessage('Fejl under ændring af samtale. Prøv venligst igen senere.', 'danger'));
          return;
        }

        this.props.history.push('/conversations');
      });
    }
  }

  /**
   * Handle when the outbound message field changes.
   */
  handleOutboundMessageChange = (e) => {
    this.props.dispatch(setOutboundMessage(this.props.conversation.id, e.target.value));
  }

  /**
   * Handle sending a message.
   */
  handleSendMessage = (e) => {
    e.preventDefault();
    this.setState({doneWorking: false});
    sendMessage(this.props.conversation.id, this.props.outboundMessage, this.props.token, this.props.history, (response) => {
      this.setState({doneWorking: true});
      if (response.status !== 200) {
        this.props.dispatch(addMessage('Fejl under afsending af besked. Prøv venligst igen senere.', 'danger'));
        return;
      }
      this.props.dispatch(setOutboundMessage(this.props.conversation.id, ''));
      this.props.onConversationUpdate();
    });
  }

  /**
   * Fetch messages for the conversation.
   */
  fetchMessages = () => {
    window.clearTimeout(this.updateTimeout);
    getMessages(this.props.conversation.id, 0, 1000, this.props.token, this.props.history, (response) => {
      if (response.status !== 200) {
        this.props.dispatch(addMessage('Fejl under hentning af beskeder. Prøv venligst igen senere.', 'danger'));
        return;
      }

      response.json().then((data) => {
        var messages = data.items;
        messages.reverse();
        this.setState({messages: messages});
      });

      // Update messages list every 5 seconds.
      window.clearTimeout(this.updateTimeout);
      this.updateTimeout = window.setTimeout(() => {
        this.fetchMessages();
      }, 10000);
    });
  }

  /**
   * Fetch all tags.
   */
  fetchTags = () => {
    getTags(this.props.token, this.props.history, (response) => {
      if (response.status !== 200) {
        this.props.dispatch(addMessage('Fejl under hentning af tags. Prøv venligst igen senere.', 'danger'));
      }

      response.json().then((data) => {
        var allTags = [];
        var tagsObj = {};
        data.forEach((group) => {
          allTags.push({
            label: group.name,
            value: group.id,
            disabled: true,
          });

          group.tags.forEach((tag) => {
            allTags.push({
              label: tag.name,
              value: tag.id,
            });
            tagsObj[tag.id] = {
              label: tag.name,
              value: tag.id,
            }
          });
        });

        var conversationTags = [];
        this.props.conversation.tags.forEach((conversationTag) => {
          conversationTags.push(tagsObj[conversationTag.id]);
        });

        this.setState({allTags: allTags, tags: conversationTags});
      });
    });
  }

  /**
   * Scroll to bottom of messages view.
   */
  scrollToBottom = () => {
    if (this.state.scrolledToBottom) {
      this.messages.scrollTop = this.messages.scrollHeight - this.messages.offsetHeight + 3;
    }
  }

  /**
   * Handle changes to info fields.
   */
  handleInfoFieldChange = (fieldName, e) => {
    var modifier = {};
    modifier[fieldName] = e.target.value;
    this.setState(modifier);

    // We don't want to trigger a request every time the user touches his
    // keyboard. Only trigger when he has not done so in half a second.
    if (this.saveTimeout !== undefined) {
      window.clearTimeout(this.saveTimeout);
    }
    this.saveTimeout = window.setTimeout(() => {
      this.setState({doneWorking: false});
      var fieldNames = ['name', 'notes', 'age', 'gender'];
      var fields = {};
      fieldNames.forEach((fieldName) => {
        var newValue;
        if (this.state[fieldName] === '_none') {
          newValue = null;
        } else {
          newValue = this.state[fieldName];
        }
        if (newValue !== this.props.conversation[fieldName]) {
          fields[fieldName] = newValue;
        }
      });
      saveConversation(this.props.conversation.id, fields, this.props.token, this.props.history, (response) => {
        if (response.status !== 200) {
          this.props.dispatch(addMessage('Fejl under gemning af samtale. Prøv venligst igen senere.', 'danger'));
          this.setState({doneWorking: true});
          return;
        }
        this.setState({doneWorking: true});
      });
    }, 500);
  }

  /**
   * Handle scrolling in messages.
   */
  handleScroll = (e) => {
    var scrolledToBottom = e.target.scrollTop >= (e.target.scrollHeight - e.target.offsetHeight);
    if (this.state.scrolledToBottom !== scrolledToBottom) {
      this.setState({scrolledToBottom: scrolledToBottom});
    }
  }

  /**
   * Fetch standard texts.
   */
  fetchStandardTexts = () => {
    getStandardTexts(this.props.user.id, this.props.token, this.props.history, (response) => {
      if (response.status !== 200) {
        this.props.dispatch(addMessage('Fejl under hentning af standardtekster. Prøv venligst igen senere.', 'danger'));
        return;
      }

      response.json().then((data) => {
        var items = {};
        data.items.forEach((item) => {
          items[item.id] = item;
        });
        this.setState({standardTexts: items});
      });
    });
  }

  /**
   * Handle change to standard text dropdown.
   */
  handleStandardTextChange = (e) => {
    if (this.props.outboundMessage !== '') {
        if (!window.confirm('Vil du overskrive nuværende besked med standardbeskeden?')) {
            return;
        }
    }

    this.props.dispatch(setOutboundMessage(this.props.conversation.id, this.state.standardTexts[e.target.value].message));

  }

  /**
   * Handle when tags change.
   */
  handleTagsChange = (newTags) => {
    var oldTags = this.state.tags;
    var deleted = oldTags.filter(function(i) {return newTags.indexOf(i) < 0;});
    deleted.forEach((deletedTag) => {
      untagConversation(this.props.conversation.id, deletedTag.value, this.props.token, this.props.history, (response) => {
        if (response.status !== 200) {
          this.props.dispatch(addMessage('Fejl under untagging. Prøv venligst igen senere.', 'danger'));
        }
      });
    });
    var added = newTags.filter(function(i) {return oldTags.indexOf(i) < 0;});
    added.forEach((addedTag) => {
      tagConversation(this.props.conversation.id, addedTag.value, this.props.token, this.props.history, (response) => {
        if (response.status !== 200) {
          this.props.dispatch(addMessage('Fejl under tagging. Prøv venligst igen senere.', 'danger'));
        }
      });
    });
    this.setState({tags: newTags});
  }

  /** @inheritdoc */
  componentDidMount = () => {
    this.fetchMessages();
    this.fetchTags();
    this.fetchStandardTexts();
    this.scrollToBottom();
  }
  /** @inheritdoc */
  componentDidUpdate = () => {
    if (this.state.messages === null) {
      this.fetchMessages();
    }
    this.scrollToBottom();
  }
  componentWillReceiveProps = () => {
  }
  /** @inheritdoc */
  componentWillUnmount = () => {
    window.clearTimeout(this.updateTimeout);
  }

  /** @inheritdoc */
  render() {
    moment.locale('da');
    return (
      <div className="col-sm-12 col-md-9">
        <div className="tab-content" id="nav-tabContent">
          <div className="tab-pane fade show active" id="list-1" role="tabpanel" aria-labelledby="list-1-list">
            <div className="row">
              <div className="col-sm-8">
                <div className="widget">
                  <WaitForState keys={['doneWorking']} state={this.state} />
                  <h3 className="section-heading">Samtale  <WaitForState keys={['messages']} state={this.state}>{this.props.conversation.user_wait_from && <span className="text-danger">(Sidste besked for {moment(this.props.conversation.user_wait_from).fromNow()})</span>}</WaitForState></h3>
                  {this.props.conversation.advisor_id === null && this.props.conversation.status !== 'closed' && <div className="form-group">
                    <button className="btn btn-primary" onClick={this.handleTake}>Overtag samtale</button>
                  </div>}
                  <div className="chat-messages" onScroll={this.handleScroll} ref={(el) => { this.messages = el; }}>
                    <WaitForState keys={['messages']} state={this.state}>
                      {this.state.messages && this.state.messages.map((message) => {
                        if (message.direction !== 'event') {
                          var messageClass = 'message-' + message.direction;
                          if (message.autoreply) {
                              messageClass += ' message-autoreply';
                          }
                          return (
                            <div className={messageClass} key={message.id}>
                              <ul className="message-in-meta">
                                <li>{moment(message.created_at).format('H:mm:ss')} <small>{moment(message.created_at).format('DD/MM-YY')}</small>{message.autoreply ? <small> - Autosvar</small> : null}</li>
                              </ul>
                              <p>{emojify(message.message)}</p>
                            </div>
                          )
                        } else {
                            var key = message.event + '-' + message.created_at;
                            return <div key={key} className='message-event'><span className="text">{message.message} - <small>{moment(message.created_at).format('H:mm:ss')} {moment(message.created_at).format('DD/MM-YY')}</small></span></div>
                        }
                      })}
                    </WaitForState>
                  </div>
                  {this.props.conversation.advisor_id === this.props.user.id && (
                    <div className="chat-message">
                      <form>
                        <div className="form-group">
                          <label htmlFor="messageControlTextarea">Skriv besked</label>
                          <select className="form-control" rows={3} value="choose" onChange={this.handleStandardTextChange}>
                            <option value="choose">Vælg standardbesked for at indsætte</option>
                            { this.state.standardTexts && Object.keys(this.state.standardTexts).map((standardTextId) => {
                                var standardText = this.state.standardTexts[standardTextId];
                                return (
                                  <option key={standardText.id} value={standardText.id}>{standardText.name}</option>
                                )
                            })}
                          </select>
                          <textarea className="form-control" id="messageControlTextarea" rows={3} value={this.props.outboundMessage} onChange={this.handleOutboundMessageChange} />
                        </div>
                        <div className="form-group">
                          <button id="messageControlButton" className="btn btn-primary" onClick={this.handleSendMessage}>Send besked</button>
                        </div>
                      </form>
                    </div>
                  )}
                </div>
              </div>
              <div className="col-sm-4">
                <div className="widget">
                  <h3 className="section-heading">Oplysninger</h3>
                  <form>
                    <div className="form-group">
                      <label htmlFor="name">Alder</label>
                      <input type="text" className="form-control" id="name" placeholder="Alder" disabled={this.props.conversation.advisor_id === this.props.user.id ? '' : 'disabled'} value={this.state.age} onChange={(e) => { this.handleInfoFieldChange('age', e); }} />
                    </div>
                    <div className="form-group">
                      <label htmlFor="status">Køn</label>
                      <select className="form-control" id="status" disabled={this.props.conversation.advisor_id === this.props.user.id ? '' : 'disabled'} value={this.state.gender} onChange={(e) => { this.handleInfoFieldChange('gender', e); }}>
                        <option value="_none">Vælg køn</option>
                        <option value="male">Dreng</option>
                        <option value="female">Pige</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label htmlFor="status">Tags</label>
                      <Select
                        name="tags"
                        value={this.state.tags}
                        onChange={this.handleTagsChange}
                        options={this.state.allTags}
                        disabled={this.props.conversation.advisor_id !== this.props.user.id}
                        multi
                        closeOnSelect={false}
                        placeholder="Vælg tags..."
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="notes">Andre noter</label>
                      <textarea className="form-control" id="notes" disabled={this.props.conversation.advisor_id === this.props.user.id ? '' : 'disabled'} rows={3} value={this.state.notes} onChange={(e) => { this.handleInfoFieldChange('notes', e); }} />
                    </div>
                    {this.props.conversation.advisor_id === this.props.user.id && <div className="btn-group text-center" role="group" aria-label="Samtaler">
                      <button type="button" className="btn btn-secondary" onClick={this.handleWaive}>Læg i kø</button>
                      <button type="button" className="btn btn-danger" onClick={this.handleClose}>Afslut</button>
                    </div>}
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className="tab-pane fade" id="list-2" role="tabpanel" aria-labelledby="list-2-list">...</div>
          <div className="tab-pane fade" id="list-3" role="tabpanel" aria-labelledby="list-3-list">...</div>
          <div className="tab-pane fade" id="list-4" role="tabpanel" aria-labelledby="list-4-list">...</div>
        </div>
      </div>
    );
  }
}

export default withRouter(withUser(connect()(Conversation)));



// WEBPACK FOOTER //
// ./src/components/ConversationOverview/components/Conversation/index.js